import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loder/loader";
import { getItem, setItem } from "./localStorage";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [theme, setTheme] = useState(() => {
    const storedTheme = getItem("theme");
    return storedTheme || "healthCare";
  });
  const [brandId, setBrandId] = useState(() =>
    theme === "healthCare" ? 1 : 2,
  );
  const navigate = useNavigate();
  const toggleTheme = () => {
    setIsLoading(true);
    navigate("/dashboard");
    setTheme((prevTheme) =>
      prevTheme === "healthCare" ? "primeCare" : "healthCare"
    );
  };

  //  Set Brand Id as per change brand Like healthCare and Primecare
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setItem("theme", theme);
      const refBrandId = theme === "healthCare" ? 1 : 2;
      setItem("refBrandId", refBrandId);
      setBrandId(refBrandId);
      setIsLoading(false);
    }, 200); // debounce with 300ms

    return () => clearTimeout(timeoutId);
  }, [theme]);

  return (
    <>
      {isLoading && <Loader loaderTransform="loaderTransform" />}
      <ThemeContext.Provider value={{ theme, toggleTheme, brandId, isLoading }}>
        {children}
      </ThemeContext.Provider>
    </>
  );
};
